import utils from "../services/utils";
import api from "../api";
import moment from "moment";
import store from "../store";

const state = () => ({
  filters: {
    // Make sure to update resetFilters
    campaigns: [],
    users: [],
    columnType: 'week',
    columnCount: 4
  },
  activeTab: 'Comms',
  weeklyGoals: {},
  monthlyGoals: {},
  kpiRowInfo: {
    'Comms': {
      'totalCalls': {
        label: 'Total Calls',
        description: 'All Calls that Occurred between the start and end time',
        recordsEndpoint: 'total-calls',
        permissionCheck: null,
        goalPrefix: 'total_calls',
        amounts: [],
      },
      'totalTexts': {
        label: 'Total Texts',
        description: 'All Texts that Occurred between the start and end time',
        recordsEndpoint: 'total-texts',
        permissionCheck: null,
        goalPrefix: 'total_texts',
        amounts: [],
      },
      'totalAnsweredCalls': {
        label: 'Total Answered Calls',
        description: 'All Inbound Calls that were answered between the start and end time',
        recordsEndpoint: 'total-answered-calls',
        permissionCheck: null,
        goalPrefix: 'total_answered_calls',
        amounts: [],
      },
      'totalInboundCalls': {
        label: 'Total Inbound Calls',
        description: 'All Inbound Calls that Occurred between the start and end time',
        recordsEndpoint: 'total-inbound-calls',
        permissionCheck: null,
        goalPrefix: 'total_inbound_calls',
        amounts: [],
      },
      'totalInboundTexts': {
        label: 'Total Inbound Texts',
        description: 'All Inbound Texts that Occurred between the start and end time',
        recordsEndpoint: 'total-inbound-texts',
        permissionCheck: null,
        goalPrefix: 'total_inbound_texts',
        amounts: [],
      },
      'totalMissedCalls': {
        label: 'Total Missed Calls',
        description: 'All Inbound Calls that were not answered between the start and end time',
        recordsEndpoint: 'total-missed-calls',
        permissionCheck: null,
        goalPrefix: 'total_missed_calls',
        amounts: [],
      },
      'totalOutboundCalls': {
        label: 'Total Outbound Calls',
        description: 'All Outbound Calls that Occurred between the start and end time',
        recordsEndpoint: 'total-outbound-calls',
        permissionCheck: null,
        goalPrefix: 'total_outbound_calls',
        amounts: [],
      },
      'totalOutboundTexts': {
        label: 'Total Outbound Texts',
        description: 'All Outbound Texts that Occurred between the start and end time',
        recordsEndpoint: 'total-outbound-texts',
        permissionCheck: null,
        goalPrefix: 'total_outbound_texts',
        amounts: [],
      },
      'averageCallDuration': {
        label: 'Average Call Duration',
        description: 'The average call duration in seconds of all Calls between the start and end time',
        recordsEndpoint: 'average-call-duration',
        permissionCheck: null,
        goalPrefix: 'average_call_duration',
        amounts: [],
      }
    },
    'Leads': {
      'recordsCreatedCount': {
        label: 'New Qualified Leads',
        description: 'All Leads that were created between the start and end time, except those that have been Dead or Not a Lead',
        recordsEndpoint: 'records-created',
        permissionCheck: null,
        goalPrefix: 'records_created',
        amounts: [],
      },
      'recordsCreatedByFirstTimeCallersCount': {
        label: 'Leads created by 1st-time callers',
        description: 'All Leads that were created by an incoming Call between the start and end time',
        recordsEndpoint: 'records-created-by-first-time-callers',
        permissionCheck: null,
        goalPrefix: 'records_created_by_first_time_callers',
        amounts: [],
      },
      'recordsCreatedByFirstTimeTextersCount': {
        label: 'Leads created by 1st-time texters',
        description: 'All Leads that were created by an incoming Text between the start and end time',
        recordsEndpoint: 'records-created-by-first-time-texters',
        permissionCheck: null,
        goalPrefix: 'records_created_by_first_time_texters',
        amounts: [],
      },
      'recordsCreatedByWebhooksCount': {
        label: 'Leads created by Webhooks',
        description: 'All Leads that were created by a Webhook between the start and end time',
        recordsEndpoint: 'records-created-by-webhooks',
        permissionCheck: null,
        goalPrefix: 'records_created_by_webhooks',
        amounts: [],
      },
      'recordsCreatedManuallyCount': {
        label: 'Leads created manually',
        description: 'All Leads that were created by a User between the start and end time',
        recordsEndpoint: 'records-created-manually',
        permissionCheck: null,
        goalPrefix: 'records_created_manually',
        amounts: [],
      },
      'recordsWithAppointmentsSetCount': {
        label: 'Leads w/ Appointment',
        description: 'All Leads that have an Appointment created between the start and end time',
        recordsEndpoint: 'total-appointments-set',
        permissionCheck: null,
        goalPrefix: 'records_with_appointments_set',
        amounts: [],
      },
      'recordsWithOffersMadeCount': {
        label: 'Leads w/ Offers Made',
        description: 'All Leads that have a Buying Offer Date between the start and end time',
        recordsEndpoint: 'records-with-offers-made',
        permissionCheck: null,
        goalPrefix: 'records_with_offers_made',
        amounts: [],
      },
      'recordsWithAcceptedOffersCount': {
        label: 'Leads w/ Offers Accepted',
        description: 'All Leads that have an Offer Accepted Date between the start and end time',
        recordsEndpoint: 'records-with-accepted-offers',
        permissionCheck: null,
        goalPrefix: 'records_with_accepted_offers',
        amounts: [],
      },
      'recordsWithContractsCount': {
        label: 'Leads w/ Contracts',
        description: 'All Leads that have an Contract Date between the start and end time',
        recordsEndpoint: 'records-with-contracts',
        permissionCheck: null,
        goalPrefix: 'records_with_contracts',
        amounts: [],
      },
      'recordsPutInFollowUpCount': {
        label: 'Added to Follow Up',
        description: 'All Leads that where added to a Follow Up Sequence between the start and end time, same record can appear in multiple time frames if it was added to multiple follow up sequences',
        recordsEndpoint: 'records-put-in-follow-up',
        permissionCheck: null,
        goalPrefix: 'records_put_in_follow_up',
        amounts: [],
      },
    },
    'Appointments': {
      'totalAppointmentsSetCount': {
        label: 'Total Appointments Set',
        description: 'All Appointments that had an Appointment created between the start and end time',
        recordsEndpoint: 'records-with-appointments-set',
        permissionCheck: null,
        goalPrefix: 'total_appointments_set',
        amounts: [],
      },
      'appointmentsCancelledByBuyerCount': {
        label: 'Appointments Cancelled by Us',
        description: 'All Appointments that had an Appointment Canceled By A User between the start and end time',
        recordsEndpoint: 'appointments-cancelled-by-buyer',
        permissionCheck: null,
        goalPrefix: 'appointments_cancelled_by_buyer',
        amounts: [],
      },
      'appointmentsCancelledBySellerCount': {
        label: 'Appointments Cancelled by Contact',
        description: 'All Appointments that had an Appointment Canceled By A Contact between the start and end time',
        recordsEndpoint: 'appointments-cancelled-by-seller',
        permissionCheck: null,
        goalPrefix: 'appointments_cancelled_by_seller',
        amounts: [],
      },
    },
    'Wholesale': {
      'wholesaleContracted': {
        label: 'Wholesale Contracted',
        description: 'All Leads that have a Contracted Date between the start and end time',
        recordsEndpoint: 'wholesale-contracted',
        permissionCheck: null,
        goalPrefix: 'wholesale_contracted',
        amounts: [],
      },
      'wholesaleProjectedProfit': {
        label: 'Wholesale Projected Profit',
        description: 'The Sum of the Leads Projected Profit, that have a Contracted Date between the start and end time',
        recordsEndpoint: 'wholesale-projected-profit',
        permissionCheck: 'can_access_financial_stats',
        goalPrefix: 'wholesale_projected_profit',
        amounts: [],
      },
      'wholesaleActualProfit': {
        label: 'Wholesale Actual Profit',
        description: 'The Sum of the Leads Actual Profit, that have a Selling Closing Date between the start and end time',
        recordsEndpoint: 'wholesale-actual-profit',
        permissionCheck: 'can_access_financial_stats',
        goalPrefix: 'wholesale_actual_profit',
        amounts: [],
      },
      'wholesaleCompleted': {
        label: 'Wholesales Completed',
        description: 'All Leads that where added to Completed state, and also have a Selling Closing Date between the start and end time',
        recordsEndpoint: 'wholesale-completed',
        permissionCheck: null,
        goalPrefix: 'wholesale_completed',
        amounts: [],
      },
    },
    'FlipAndFix': {
      'dealsPurchasedCount': {
        label: 'Fix and Flip Purchases',
        description: 'All Leads that have a Closing Date between the start and end time',
        recordsEndpoint: 'deals-purchased',
        permissionCheck: null,
        goalPrefix: 'deals_purchased',
        amounts: [],
      },
      'projectedProfitCount': {
        label: 'Fix and Flip Projected Profit',
        description: 'The Sum of the Leads Projected Profit, that have a Buying Closing Date between the start and end time',
        recordsEndpoint: 'projected-profit',
        permissionCheck: 'can_access_financial_stats',
        goalPrefix: 'projected_profit',
        amounts: [],
      },
      'actualProfitCount': {
        label: 'Fix and Flip Actual Profit',
        description: 'The Sum of the Leads Actual Profit, that have a Selling Closing Date between the start and end time',
        recordsEndpoint: 'actual-profit',
        permissionCheck: 'can_access_financial_stats',
        goalPrefix: 'actual_profit',
        amounts: [],
      },
      'completedRecords': {
        label: 'Fix and Flips Completed',
        description: 'All Leads that where added to Completed state, and also have a Selling Closing Date between the start and end time',
        recordsEndpoint: 'completed-records',
        permissionCheck: null,
        goalPrefix: 'completed_records',
        amounts: [],
      },
    },
    'Novation': {
      'novationDealsPurchasedCount': {
        label: 'Novation Purchases',
        description: 'All Leads that have a Buying Closing Date between the start and end time',
        recordsEndpoint: 'novation-deals-purchased',
        permissionCheck: null,
        goalPrefix: 'novation_deals_purchased',
        amounts: [],
      },
      'novationProjectedProfitCount': {
        label: 'Novation Projected Profit',
        description: 'The Sum of the Leads Projected Profit, that have a Buying Closing Date between the start and end time',
        recordsEndpoint: 'novation-projected-profit',
        permissionCheck: 'can_access_financial_stats',
        goalPrefix: 'novation_projected_profit',
        amounts: [],
      },
      // 'novationActualProfitCount': {
      //   label: 'Novation Actual Profit',
      //   description: 'The Sum of the Leads Actual Profit, that have a Selling Closing Date between the start and end time',
      //   recordsEndpoint: 'novation-actual-profit',
      //   permissionCheck: 'can_access_financial_stats',
      //   goalPrefix: 'novation_actual_profit',
      //   amounts: [],
      // },
      // 'novationCompletedRecords': {
      //   label: 'Novations Completed',
      //   description: 'All Leads that where added to Completed state, and also have a Selling Closing Date between the start and end time',
      //   recordsEndpoint: 'novation-completed-records',
      //   permissionCheck: null,
      //   goalPrefix: 'novation_completed_records',
      //   amounts: [],
      // },
    },
  }
});

const getters = {
  kpiRowInfo(state) {
    return state.kpiRowInfo[state.activeTab];
  },
  filters(state, getters, rootState, rootGetters) {
    let kpisFilter = utils.clone(state.filters);

    kpisFilter.campaigns = state.filters.campaigns.filter(campaignId => {
      if (campaignId === null) return true;
      return rootGetters.activeCampaigns.find(activeCampaign => activeCampaign.id === campaignId);
    });

    return kpisFilter;
  },
  goals(state) {
    if(state.filters.columnType === 'week') return state.weeklyGoals
    if(state.filters.columnType === 'month') return state.monthlyGoals
  },
  todayColumn() {
    return {
      startAt: moment().startOf('day').toISOString(),
      endAt: moment().endOf('day').toISOString(),
      label: 'Today'
    }
  },
  columnData(state) {
    let columns = [];

    // Add weekly columns
    if(state.filters.columnType === 'week') {
      columns.push({
        startAt: moment().startOf('week').toISOString(),
        endAt: moment().toISOString(),
        label: 'This Week'
      });

      for (let i = 1; i <= state.filters.columnCount; i++) {
        const startAt = moment().subtract(i, 'week').startOf('week');
        const endAt = moment().subtract(i, 'week').endOf('week');

        columns.push({
          startAt: startAt.toISOString(),
          endAt: endAt.toISOString(),
          label: startAt.format("MMM D") + ' - ' + endAt.format("MMM D")
        });
      }
    }

    // Add monthly columns
    if(state.filters.columnType === 'month') {
      columns.push({
        startAt: moment().startOf('month').toISOString(),
        endAt: moment().toISOString(),
        label: 'This Month'
      });

      for (let i = 1; i <= state.filters.columnCount; i++) {
        const startAt = moment().subtract(i, 'month').startOf('month');
        const endAt = moment().subtract(i, 'month').endOf('month');

        columns.push({
          startAt: startAt.toISOString(),
          endAt: endAt.toISOString(),
          label: startAt.format("MMMM")
        });
      }
    }

    return columns;
  },
};

const mutations = {
  // Set one filter
  setOneFilter(state, [filter, value]) {
    // change filter value
    state.filters[filter] = value;
    // store.dispatch('updateUserAppFilter')
  },
  setActiveTab(state, tab) {
    // make sure this match the filters declared on state
    state.activeTab = tab
  },
  setUserFilters(state, filters) {
    // make sure this match the filters declared on state
    state.filters = {...state.filters, ...filters} // filters
  },
  // Reset filters
  reset(state) {
    // Make sure to update state default
    state.filters = {
      campaigns: [],
      users: [],
      columnType: 'week',
      columnCount: 4
    };

    store.dispatch('updateUserAppFilter')
  },
  addKpiRowInfoAmount(state, data) {
    const [key, value] = data;
    state.kpiRowInfo[state.activeTab][key].amounts.push(value);
  },
  resetKpiRowInfoAmount(state) {
    let columns = state.kpiRowInfo[state.activeTab];
    Object.entries(columns).forEach(row => {
      const [key] = row;
      state.kpiRowInfo[state.activeTab][key].amounts = []
    });
  },
  setGoals(state, data) {
    state.weeklyGoals = data.weekly
    state.monthlyGoals = data.monthly
  },
};

const actions = {
  setup({commit, rootGetters}) {
    return api.markets.getGoals(rootGetters.market.id).then(response => {
      commit('setGoals', response.data)
    });
  },
  getColumnAmounts({commit, state, getters}, data) {
    if (state.activeTab === 'Comms') {
      Promise.all([
        api.stats.getKPIStats([
          'totalMissedCalls',
          'totalOutboundCalls',
          'totalOutboundTexts',
          'totalMissedCalls',
          'totalOutboundCalls',
        ], data),
        api.stats.getKPIStats([
          'totalOutboundTexts',
          'totalCalls',
          'totalTexts',
          'totalAnsweredCalls',
          'totalInboundCalls',
          'totalInboundTexts',
        ], data),
      ]).then(([firstHalf, secondHalf]) => {
        let amounts = {
          ...firstHalf,
          ...secondHalf,
        };

        // Add amount to kpiRowInfo amounts
        Object.entries(amounts).forEach(entry => {
          commit('addKpiRowInfoAmount', entry)
        });

        // Make sure to return amounts to component, so it can be saved locally
        return amounts;
      })
    }

    return api.stats.getKPIStats(Object.keys(getters.kpiRowInfo), data).then((response) => {
      let amounts = response.data;

      // Add amount to kpiRowInfo amounts
      Object.entries(amounts).forEach(entry => {
        commit('addKpiRowInfoAmount', entry)
      });

      // Make sure to return amounts to component, so it can be saved locally
      return amounts;
    });
  },
  tearDown({commit}) {
    commit('reset');
  },
};

const StatsStore = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default StatsStore;
